import React from "react";

const Frontend = () => {
   return(
      <div className="skills__content">
         <h3 className="skills__title">Frontend Developer</h3>

         <div className="skills__box">                                            {/*Main skill block*/}
            <div className="skills__group">                                       {/*Group-1*/}
               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">JavaScript</h3>
                     <span className="skills__level">Advanced</span>
                  </div>
               </div>

               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">React</h3>
                     <span className="skills__level">Intermediate</span>
                  </div>
               </div>

               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">Java: Spring, Thymeleaf</h3>
                     <span className="skills__level">Basic</span>
                  </div>
               </div>

               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">BootStrap</h3>
                     <span className="skills__level">Basic</span>
                  </div>
               </div>

               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">Java Fx</h3>
                     <span className="skills__level">Basic</span>
                  </div>
               </div>
            </div>

            <div className="skills__group">                                      {/*Group-2*/}
               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">jQuery</h3>
                     <span className="skills__level">Intermediate</span>
                  </div>
               </div>

               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">Python GUIs</h3>
                     <span className="skills__level">Advanced</span>
                  </div>
               </div>

               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">Git & GitHub</h3>
                     <span className="skills__level">Advanced</span>
                  </div>
               </div>

               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">.NET Windows Forms</h3>
                     <span className="skills__level">Basic</span>
                  </div>
               </div>

               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">HTML, CSS</h3>
                     <span className="skills__level">Intermediate</span>
                  </div>
               </div>
               
               <div className="skills__data">
                  <i className='bx bx-badge-check'></i>

                  <div>
                     <h3 className="skills__name">Power Apps</h3>
                     <span className="skills__level">Intermediate</span>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default Frontend;